import { render, staticRenderFns } from "./DocumentContent.vue?vue&type=template&id=583184cc&"
import script from "./DocumentContent.vue?vue&type=script&lang=js&"
export * from "./DocumentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports